<mat-card class="data-count-card">
  <mat-card-header>
    <mat-card-title class="data-count-card-title">{{ title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content *ngIf="!loading && !error" class="data-count-card-content">
    <p class="data-count-card-content-item-count">{{ dataCount }}</p>
    <div class="data-count-card-actions">
      <a *ngIf="exportEnabled" (click)="exportData()" class="data-count-card-action" matTooltip="{{ tooltip }}"
        >Export Data</a
      >
      <span *ngIf="!exportEnabled" class="data-count-card-action-disabled" matTooltip="{{ tooltip }}">Export Data</span>
      <a
        *ngIf="enableViewData && reportLink"
        (click)="viewData()"
        class="data-count-card-action"
        matTooltip="Go to associated report."
        >View Data</a
      >
    </div>
  </mat-card-content>
  <mat-card-content *ngIf="loading && !error" class="data-count-card-content-loading">
    <mat-spinner></mat-spinner>
  </mat-card-content>
  <mat-card-content *ngIf="error" class="data-count-card-content">
    <mat-icon class="data-count-card-content-error">error</mat-icon>
    <p>There was an error loading the data</p>
    <a (click)="retry()" class="data-count-card-action">Retry</a>
  </mat-card-content>
</mat-card>
